/**
 * Kill-switch for the full-screen onboarding funnel (profile + host wizard).
 *
 * - `NEXT_PUBLIC_SKIP_NEW_ONBOARDING_FLOW=true` — applies at build time (instant rollback via redeploy).
 * - API flag `skip_new_onboarding_flow` — toggled per user/org in admin (`feature-flags/my`).
 *
 * When either is on, clients skip forced navigation to `/onboarding`; users can still open
 * profile from Account and complete merchant setup where enforced by payments API.
 */

export const WEB_SKIP_NEW_ONBOARDING_FLOW_ENV =
  typeof process !== "undefined" &&
  process.env.NEXT_PUBLIC_SKIP_NEW_ONBOARDING_FLOW === "true";

export function shouldSkipNewOnboardingFlow(flagFromApi: boolean): boolean {
  return WEB_SKIP_NEW_ONBOARDING_FLOW_ENV || flagFromApi;
}

/** Where to send users who would otherwise hit `/onboarding` after auth. */
export function skipOnboardingLandingHref(redirectPath: string | null | undefined): string {
  if (redirectPath && redirectPath.length > 0) return redirectPath;
  return "/";
}
